import React, { useRef, useState, useEffect } from 'react';
import { uniqueId } from 'lodash';

import { MdFileUpload } from 'react-icons/md';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';

import { getBase64 } from '../../../utils/array';

import { WarningToast } from '../Toast';

import { Container, IconContainer, HiddenInput } from './styles';

function UploadBox({
  file,
  maxQuantityFiles,
  maxSizeFiles,
  validExtension,
  applyValidation,
  invalidCallback = () => {},
  setFiles,
  loading,
}) {
  const [data, setData] = useState([]);
  const [uploadError, setUploadError] = useState(false);

  const fileInputRef = useRef(null);

  function openFileDialog() {
    fileInputRef.current.click();
  }

  function onFilesAdded(e) {
    setUploadError(false);
    setData([]);

    const { files } = e.target;
    handleFiles(files);
  }

  async function handleFiles(fileArray) {
    const errors = {
      hasMaxSize: false,
      hasMaxQuantity: false,
      hasValidExtension: false,
    };

    const fileErrors = [];
    let newFiles = await Promise.all(
      Object.values(fileArray).map(async (newFile) => {
        const base64 = await getBase64(newFile);
        return {
          newFile,
          name: newFile.name,
          readableSize: newFile.size,
          preview: URL.createObjectURL(newFile),
          progress: 0,
          uploaded: false,
          error: false,
          base64,
          idFile: uuidv4(),
          idLista: file.idLista,
          TipoMovimentacao: null,
          codigoContratante: null,
          descricao: '',
        };
      })
    );

    if (applyValidation) {
      newFiles = newFiles.filter((item) => {
        errors.hasMaxSize = false;
        errors.hasValidExtension = false;
        if (item.readableSize > maxSizeFiles) errors.hasMaxSize = true;

        if (!validExtension.includes(item.name.split('.').pop().toLowerCase()))
          errors.hasValidExtension = true;

        if (newFiles.length > maxQuantityFiles) errors.hasMaxQuantity = true;
        if (
          !(item.readableSize > maxSizeFiles) &&
          validExtension.includes(item.name.split('.').pop().toLowerCase()) &&
          newFiles.length <= maxQuantityFiles
        ) {
          return item;
        }
        const { hasMaxQuantity, ...rest } = errors;
        fileErrors.push({ error: rest, name: item.name });
      });

      invalidCallback({ fileErrors, hasMaxQuantity: errors.hasMaxQuantity });
    }
    if (newFiles.length > 0) setFiles(newFiles);
  }

  function dragOver(e) {
    e.preventDefault();
  }
  function dragEnter(e) {
    e.preventDefault();
  }
  function dragLeave(e) {
    e.preventDefault();
  }
  function fileDrop(e) {
    e.preventDefault();
    const { files } = e.dataTransfer;

    if (files.length) {
      handleFiles(files);
    }
  }

  return (
    <Container
      height="30"
      width="504"
      onClick={openFileDialog}
      onChange={onFilesAdded}
      onDragOver={dragOver}
      onDragEnter={dragEnter}
      onDragLeave={dragLeave}
      onDrop={fileDrop}
      disabled={loading}
    >
      <p>{file.name}</p>
      <HiddenInput
        ref={fileInputRef}
        className="FileInput"
        type="file"
        multiple
        disabled={loading}
      />
      <IconContainer>
        <MdFileUpload color="#808080" />
      </IconContainer>
    </Container>
  );
}

export default UploadBox;
